// ChatGPT Base Pixel - Brickell US Shopify -->
!function(w, d, s, u) { 
  if (w.oaiq) return; 
  var q = function() { q.q.push(arguments); }; 
  q.q = []; 
  w.oaiq = q; 
  var j = d.createElement(s); 
  j.async = 1; 
  j.src = u; 
  var f = d.getElementsByTagName(s)[0]; 
  f.parentNode.insertBefore(j, f); 
}(window, document, "script", "https://bzrcdn.openai.com/sdk/oaiq.min.js");

oaiq("init", { pixelId: "CB4Z5Wfc7VcyN1FFM6wxrf", debug: true });
